// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__4jcSM","empty":"ModalGraph_empty__3Ivrf"};